import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformV2ClientResponse } from 'helpers/core';

import URLS from 'constants/urls';

const handler = ({ httpClient }, venueId) =>
  httpClient.get(URLS.stats.marketInsightsModulesList(venueId)).then(transformV2ClientResponse);

export default makeEntityScaffold('SAGA.API.STATS_MARKET_INSIGHTS_MODULES_LIST', handler, { defaultKey: 1 });
